export default __webpack_public_path__ + "f6d53783c421357e927d45a0d5d7a734.png";